module.exports = __webpack_public_path__ + "static/media/companyLogo1.fb7790e1.png";